import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import FilterResults from './widget/component/FilterResults';
//import {SmartFilterResults} from './widget/component/FilterResults';

const initResultsPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('filter-results', FilterResults, props);
    //initWidget('smart-filter-results', SmartFilterResults, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResultsPageWidgets.bind(this));
} else {
    initResultsPageWidgets();
}